import PropTypes from "prop-types";
import React from "react";
import classes from "./UILabel.scss";
import classNames from "classnames";
import { getLabelWithArchivedText } from "Utils";
import I18nHOC from "UIComponents/I18nHOC";

class UILabel extends React.PureComponent {
  render() {
    const {
      label,
      labelComponent,
      subText,
      labelStyle,
      labelClass,
      subtextClass,
      subTextStyle,
      labelContainerStyle,
      isArchived,
      t,
      customLabelClass = "",
      testId,
      isSinglePageAndNewUnitView,
    } = this.props;
    const labelClasses = classNames(
      { [classes.inputLabel]: !customLabelClass },
      { [classes[labelClass]]: !!labelClass },
      { [customLabelClass]: !!customLabelClass }
    );

    const subTextClasses = classNames(
      { [classes.subText]: true },
      { [classes[subtextClass]]: !!subtextClass }
    );

    return !!label || !!labelComponent ? (
      <div
        className={classNames(
          { [classes.container]: true },
          { [classes.containerV2]: isSinglePageAndNewUnitView }
        )}
        style={labelContainerStyle}
      >
        {labelComponent ? (
          labelComponent
        ) : label ? (
          <div className={classes.labelContainer}>
            <div
              className={labelClasses}
              style={labelStyle}
              data-test-id={testId}
            >
              {getLabelWithArchivedText({
                t,
                label,
                isArchived,
              })}
            </div>
          </div>
        ) : null}
        {!!subText && !labelComponent ? (
          <div
            className={subTextClasses}
            style={subTextStyle}
            dangerouslySetInnerHTML={{ __html: subText }}
          ></div>
        ) : null}
      </div>
    ) : null;
  }
}

UILabel.defaultProps = {
  labelStyle: {},
  label: "",
  subText: "",
  labelClass: "",
  subtextClass: "",
  subTextStyle: {},
  isArchived: false,
};

UILabel.propTypes = {
  subText: PropTypes.string,
  labelComponent: PropTypes.element,
  labelStyle: PropTypes.object,
  labelClass: PropTypes.string,
  subtextClass: PropTypes.string,
  subTextStyle: PropTypes.object,
  isArchived: PropTypes.bool,
};

export default I18nHOC({ resource: ["common"] })(UILabel);
